import { CampaignActionChecklistItemController } from './campaign-action-checklist-item.controller'

function campaignActionChecklistItem () {
  return {
    scope: {
      checklist: '<',
      disabled: '<'
    },
    restrict: 'E',
    templateUrl: '/campaigns/directives/campaign-action-checklist-item/campaign-action-checklist-item.html?$$REVISION$$',
    controller: CampaignActionChecklistItemController
  }
}

export { campaignActionChecklistItem }
